import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home.js";
import Header from "../Component/Header.js";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../LetterDigiCom/letterDigiCom-styles.css";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService.js";
import Skeleton from "react-loading-skeleton";
import "moment/locale/th";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, Col, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  TablePagination,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { BiDetail } from "react-icons/bi";
import WarningIcon from "@mui/icons-material/Warning";
import successGif from "../../images/successGiff.gif";
import {
  getRequestStatus,
  updateRequestStatus,
} from "../RequestStatus/RequestStatusService/requestStatusService.js";
import CryptoJS from "crypto-js";
import remove from "../../images/remove.png";

const RequestStatus = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const [cusTel, setCusTel] = useState("");
  let [searchParams, setSearchParams] = useSearchParams();
  const policyNo = searchParams.get("policyNo") || "";
  let navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [itemId, setItemId] = useState(null);
  const [step, setStep] = useState(1);
  const [subject, setSubject] = useState("");
  const [status, setStatus] = useState("");
  const [requestDate, setRequestDate] = useState("");
  const [textModal, setTextModal] = useState("");
  const [completeFlag, setCompleteFlag] = useState();

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const getTel = async () => {
    const result = await getParameterAPI(12);
    const payload = result.payload;
    const cusTel = payload.find((item) => item.code === "CUS_SERV_TEL");
    const variable1 = cusTel.variable1;
    setCusTel(variable1);
  };
  const [customerId, setCustomerId] = useState(
    localStorage.getItem("customer_id")
  );
  const [page, setPage] = useState(0);
  const [rowDReqStatus, setRowReqStatus] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const goBack = () => {
    if (step === 1) {
      navigate("/personal");
    } else if (step === 2) {
      setStep(1);
    }
  };

  const goToRequestStatus = () => {
    navigate(`/RequestStatusDetail`);
  };

  const handleCancel = (item) => {
    setStatus(item.status);
    console.log(item.status);
    setSubject(item.subject);
    console.log(item.subject);
    setRequestDate(item.requestDate);
    console.log(item.requestDate);
    setStep(1);
    setOpenModal(true);
  };

  const updateRequestByRow = async () => {
    const result = await updateRequestStatus(
      decryptCardNumber(customerId, process.env.REACT_APP_ENCRYPT_DATA).trim(),
      subject.trim(),
      status.trim(),
      requestDate.trim()
    );
    if (result.status) {
      setStep(2);
      setOpenModal(false);
      fetchDataReqStatus();
      setCompleteFlag(true);
    } else {
      setStep(2);
      setOpenModal(false);
      setCompleteFlag(false);
      setTextModal("ไม่สามารถยกเลิกข้อมูลคำร้องได้");
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setStep(1);
  };
  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const fetchDataReqStatus = async () => {
    setLoadingContent(true);

    const result = await getRequestStatus(
      decryptCardNumber(customerId, process.env.REACT_APP_ENCRYPT_DATA)
    );

    setTimeout(() => {
      setPage(0);
      setRowReqStatus(result.data);
      setLoadingContent(false);
    }, 1000);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    getTel();
    fetchDataReqStatus();
    // console.log(policyNo);
  }, []);

  const getStatusLabel = (status) => {
    switch (status) {
      case 'New':
        return 'รอดำเนินการ';
      case 'Taken':
        return 'กำลังดำเนินการ';
      case 'Closed':
        return 'ดำเนินการเรียบร้อย';
      case 'Canceled':
        return 'ยกเลิก';
      default:
        return '-';
    }
  };

  const statusMap = {
    New: {
      icon: '🟠', // รอดำเนินการ
      label: 'รอดำเนินการ',
    },
    Taken: {
      icon: '⏳', // กำลังดำเนินการ
      label: 'กำลังดำเนินการ',
    },
    Closed: {
      icon: '✅', // ดำเนินการเรียบร้อย
      label: 'ดำเนินการเรียบร้อย',
    },
    Canceled: {
      icon: '❌', // ยกเลิก
      label: 'ยกเลิก',
    },
  };

  const renderStatus = (status) => {
    const statusItem = statusMap[status];
    if (!statusItem) return '-';

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ fontSize: '18px' }}>{statusItem.icon}</span>
        <span>{statusItem.label}</span>
      </div>
    );
  };

  return (
    <div>
      <Header_Home />
      <Header
        title={
          step === 1 ? "สถานะคำร้อง" : step === 2 ? "ยกเลิกสถานะคำร้อง" : ""
        }
      />
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        // onClick={handleClose}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}

      <div className="frame-loan">
        <div className="containers">
          {LoadingContent && (
            <>
              <Row className="card-custom3 d-flex">
                <Col className="mt-3">
                  <Skeleton style={{ height: "30px" }} />
                  <div className="d-flex flex-row justify-content-between">
                    <Skeleton />
                  </div>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </Col>
              </Row>
              <br />
            </>
          )}
          {!LoadingContent &&
            (step === 2 ? (
              <Box
                sx={{
                  border: "1px solid rgba(255, 94, 67, 0.3) !important",
                  borderRadius: "12px !important",
                  borderWidth: "2px !important",
                  padding: 4,
                  backgroundColor: "#fff",
                  textAlign: "center",
                }}
              >
                <img
                  src={completeFlag ? successGif : remove}
                  alt="Success"
                  style={{ width: "200px", marginBottom: "20px" }}
                />
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "bold",
                    fontFamily: "Prompt, sans-serif",
                    color: "#000",
                  }}
                >
                  {completeFlag ? (
                    <>
                      ยกเลิกสถานะคำร้องสำเร็จ
                    </>
                  ) : (
                    textModal
                  )}
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  //   border: "1px solid rgba(10, 2, 0, 0.3) !important",
                  //   borderRadius: "12px !important",
                  //   borderWidth: "2px !important",
                 
                  //   backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    mb: 2,
                    ml: 1,
                    fontSize: "20px",
                    fontFamily: "Prompt-Thin",
                  }}
                >
                  ประวัติคำร้อง
                </Typography>
                <ThemeProvider theme={theme}>
                  <Box sx={{ maxHeight: 400, overflow: "auto" }}>
                    <TableContainer component={Paper}>
                      <Table aria-label="collapsible table">
                        <TableHead>
                          <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                            <TableCell align="center">วันที่ทำรายการ</TableCell>
                            <TableCell align="center">รายการคำร้อง</TableCell>
                            <TableCell align="center">สถานะ</TableCell>
                            <TableCell align="center">รายละเอียด</TableCell>
                            <TableCell align="center">การจัดการ</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowDReqStatus
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((item, idx) => (
                              <TableRow key={idx}>
                                <TableCell align="center">
                                  {item.requestDate
                                    ? String(item.requestDate)
                                      .split("-")
                                      .reverse()
                                      .join("/")
                                    : ""}
                                </TableCell>
                                <TableCell align="center">
                                  {item.subject}
                                </TableCell>
                                <TableCell align="center">
                                  {renderStatus(item.status)}
                                </TableCell>
                                <TableCell align="center">
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <IconButton
                                      size="small"
                                      sx={{
                                        border: "1px solid #ff4d4d",
                                        borderRadius: "5px",
                                        padding: "4px",
                                        color: "#ff4d4d",
                                        boxShadow:
                                          "0px 2px 4px rgba(0,0,0,0.1)",
                                        "&:hover": {
                                          backgroundColor: "#ffeaea",
                                        },
                                      }}
                                      onClick={() =>
                                        navigate("/RequestStatusDetail", {
                                          state: {
                                            requestDate: item.requestDate,
                                            subject: item.subject,
                                            status: item.status,
                                            requestDateTime: item.requestDateTime
                                          },
                                        })
                                      }
                                    >
                                      <BiDetail size={18} />
                                    </IconButton>
                                  </Box>
                                </TableCell>

                                <TableCell align="center">
                                  {item.status === "New" && (
                                    <button
                                      className="btn-address-next w-100 p-2 bold"
                                      onClick={() => handleCancel(item)}
                                    >
                                      ยกเลิก
                                    </button>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rowDReqStatus.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </ThemeProvider>
              </Box>
            ))}

          <Row className="d-flex flex-column mt-2 mb-5">
            <Col className="d-flex justify-content-start px-5">
              <button
                onClick={goBack}
                className="btn-coupon-back w-sm-100 w-lg-25 p-2 bold text-black"
              >
                ย้อนกลับ
              </button>
            </Col>
          </Row>
        </div>
        <Modal show={openModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header></Modal.Header>
          <Modal.Body
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              fontSize: "25px",
            }}
          >
            <WarningIcon style={{ fontSize: "100px", color: "#fbd34c" }} />
            <p style={{ marginTop: "20px", fontWeight: "bold" }}>
              คุณต้องการยกเลิก ?
            </p>
          </Modal.Body>
          <Modal.Footer style={{ display: "flex", justifyContent: "center" }}>
            <a
              onClick={() => setOpenModal(false)}
              type="button"
              className="mt-3 btn-back"
              style={{ minWidth: "100px", textAlign: "center" }}
            >
              ยกเลิก
            </a>
            <a
              onClick={updateRequestByRow}
              type="button"
              className="mt-3 btn-confirm"
              style={{ minWidth: "100px", textAlign: "center" }}
            >
              ตกลง
            </a>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default RequestStatus;
